module.exports = __webpack_public_path__ + "img/plant_2.11643d43.webp";